export const EXTERNAL_REGISTER_RESOURCE_MAP = Symbol(
  'client-export/withI18n/externalRegisterResourceMap'
)
export const I18N_LOADING_COUNT = Symbol('withI18n/i18nResourceLoadingCount')
